<template>
  <div class="flex-1 flex flex-col min-h-0 min-w-0">
    <div class="px-8 pt-6 pb-2 shrink-0">
      <div class="flex items-center gap-2 pb-2 max-w-[1600px] mx-auto">
        <div class="flex gap-2 overflow-x-auto custom-scrollbar min-w-0 flex-1">
          <button
            v-for="f in filterTabs"
            :key="f.value"
            type="button"
            class="px-4 py-2 rounded-full text-xs font-bold whitespace-nowrap transition-colors shrink-0"
            :class="activeFilter === f.value ? 'bg-[#1c4848] text-white shadow-md' : 'bg-white border border-[#1c4848]/10 text-[#1c4848]/60 hover:bg-[#fafbfc] hover:text-[#1c4848]'"
            @click="activeFilter = f.value"
          >
            {{ f.label }}
          </button>
        </div>
        <div class="shrink-0">
          <LanguageFilterDropdown v-model="selectedLanguageId" />
        </div>
      </div>
    </div>

    <div class="flex-1 min-h-0 overflow-y-auto custom-scrollbar p-8 pb-32">
      <div v-if="gamesStore.listLoading" class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 max-w-[1600px] mx-auto">
        <GameCardSkeleton v-for="i in 8" :key="i" />
      </div>
      <div v-else class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 max-w-[1600px] mx-auto">
        <GameCard
          v-for="game in filteredList"
          :key="game.id"
          :game="game"
          @play="$emit('play', game)"
          @edit="$emit('edit', game)"
          @delete="$emit('delete', game)"
          @duplicated="onGameDuplicated"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useGamesStore } from '@/store/games/index.js';
import GameCard from '@/components/app/dashboard/games/GameCard.vue';
import GameCardSkeleton from '@/components/app/dashboard/games/GameCardSkeleton.vue';
import LanguageFilterDropdown from '@/components/LanguageFilterDropdown.vue';

const props = defineProps({ searchQuery: { type: String, default: '' } });
defineEmits(['play', 'edit', 'delete']);

const gamesStore = useGamesStore();

const activeFilter = ref('');
const selectedLanguageId = ref('');

async function fetchWithFilters() {
  const params = selectedLanguageId.value ? { language_id: selectedLanguageId.value } : {};
  await gamesStore.fetchList(params);
}
await fetchWithFilters();

const filterTabs = [
  { value: '', label: 'All Games' },
  { value: 'match_pairs', label: 'Memory' },
  { value: 'sliding_puzzle', label: 'Puzzles' },
  { value: 'catch_star', label: 'Catch Star' },
  { value: 'color_match', label: 'Color Match' },
  { value: 'bubble_shooter', label: 'Bubble Shooter' },
  { value: 'block_stack', label: 'Stack' },
];

const filteredList = computed(() => {
  let list = gamesStore.list;
  if (activeFilter.value) list = list.filter((x) => x.game_type === activeFilter.value);
  const q = props.searchQuery?.trim()?.toLowerCase();
  if (q) list = list.filter((x) => (x.name || '').toLowerCase().includes(q));
  return list;
});

watch(selectedLanguageId, fetchWithFilters);

async function onGameDuplicated() {
  await fetchWithFilters();
}
</script>

<style scoped>
.custom-scrollbar::-webkit-scrollbar { width: 4px; height: 4px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background-color: rgba(28, 72, 72, 0.1); border-radius: 20px; }
.custom-scrollbar:hover::-webkit-scrollbar-thumb { background-color: rgba(28, 72, 72, 0.2); }
</style>
